import { HTMLAttributes, ReactHTML } from 'react'

import domPurify from 'isomorphic-dompurify'
import styled from 'styled-components'

export const sanitizer = domPurify.sanitize

const LayoutStyled = styled.div``

interface IFormatInnerHTML {
  template: string
  Layout?: typeof LayoutStyled
  as?: keyof ReactHTML
}

const FormatInnerHTML = ({
  template = '',
  Layout = LayoutStyled,
  ...props
}: HTMLAttributes<any> & IFormatInnerHTML) => {
  return (
    <Layout
      {...props}
      dangerouslySetInnerHTML={{ __html: sanitizer(template) }}
    />
  )
}

export default FormatInnerHTML
